const mauritransEN = {
  mau_nav_home: 'Home',
  mau_nav_compass: 'Compass Resources',
  mau_nav_services: 'Services',
  mau_nav_about: 'About',
  mau_nav_contact: 'Contact',
  mau_nav_quote: 'Get Quote',

  mau_hero_badge: 'A GDSATLAS Company - Leading Logistics Provider',
  mau_hero_title: 'Your Complete Logistics\n& Shipping Partner in Africa',
  mau_hero_subtitle: 'Comprehensive maritime services • International freight forwarding • End-to-end supply chain solutions',
  mau_hero_cta1: 'Explore Our Services',
  mau_hero_cta2: 'Request Quote',
  mau_hero_stat1_label: 'Annual Shipments',
  mau_hero_stat2_label: 'Service Categories',
  mau_hero_stat3: '24/7',
  mau_hero_stat3_label: 'Operations',
  mau_hero_stat4: '100%',
  mau_hero_stat4_label: 'Reliability',

  mau_about_tag: 'Who We Are',
  mau_about_title: 'Connecting Africa to\nGlobal Trade Routes',
  mau_about_p1: 'Mauritrans Shipping is a comprehensive logistics and transport shipping company, fully owned by GDSATLAS. We provide end-to-end maritime services, freight forwarding, customs clearance, and supply chain solutions across Africa and internationally.',
  mau_about_p2: 'With our extensive network, modern infrastructure, and experienced team, we ensure efficient cargo movement and supply chain reliability for businesses of all sizes. From port operations to final delivery, we handle every aspect of your logistics needs.',
  mau_about_stat1: '15+',
  mau_about_stat1_label: 'Years Experience',
  mau_about_stat2: '50+',
  mau_about_stat2_label: 'Global Partners',

  mau_svc_tag: 'Our Services',
  mau_svc_title: 'Comprehensive Logistics Solutions',
  mau_svc_subtitle: 'Nine specialized services covering every aspect of maritime logistics and supply chain management',
  mau_svc1_title: 'Shipping Agency Services',
  mau_svc1_desc: 'Comprehensive port agency services including vessel clearance, documentation, and coordination with port authorities to ensure smooth operations.',
  mau_svc2_title: 'Shipping Line Representation',
  mau_svc2_desc: 'Professional representation of international shipping lines, managing their interests and operations in Mauritanian ports and regional markets.',
  mau_svc3_title: 'Husbandry Services',
  mau_svc3_desc: 'Complete vessel husbandry including crew changes, provisions, spare parts delivery, medical assistance, and all ship-related requirements.',
  mau_svc4_title: 'Stevedoring',
  mau_svc4_desc: 'Expert cargo handling services with modern equipment and trained personnel for efficient loading and unloading of vessels.',
  mau_svc5_title: 'Shore Handling',
  mau_svc5_desc: 'Professional shore-side cargo operations including sorting, storage, and preparation for onward transportation.',
  mau_svc6_title: 'International Freight Forwarding',
  mau_svc6_desc: 'Comprehensive sea and air freight forwarding services connecting Africa to global markets with reliable logistics solutions.',
  mau_svc7_title: 'Customs Clearance',
  mau_svc7_desc: 'Expert customs brokerage services ensuring fast and compliant clearance of imports and exports through all Mauritanian ports.',
  mau_svc8_title: 'Warehousing',
  mau_svc8_desc: 'Secure storage facilities with modern inventory management systems for short-term and long-term cargo storage needs.',
  mau_svc9_title: 'Inland Transportation',
  mau_svc9_desc: 'Reliable door-to-door transportation services across Mauritania and neighboring countries with modern fleet and tracking systems.',

  mau_why_tag: 'Why Choose Mauritrans',
  mau_why_title: 'Your Trusted Logistics Partner',
  mau_why_subtitle: 'Delivering excellence through expertise, reliability, and comprehensive service coverage',
  mau_why1_title: '24/7 Operations',
  mau_why1_desc: 'Round-the-clock service ensuring your cargo moves without delays',
  mau_why2_title: 'Secure Handling',
  mau_why2_desc: 'Advanced security measures and insurance coverage for peace of mind',
  mau_why3_title: 'Global Network',
  mau_why3_desc: 'Extensive partnerships connecting Africa to worldwide markets',
  mau_why4_title: 'Expert Support',
  mau_why4_desc: 'Dedicated team providing personalized logistics solutions',
  mau_why5_title: 'Competitive Rates',
  mau_why5_desc: 'Cost-effective solutions without compromising quality',
  mau_why6_title: 'Strategic Location',
  mau_why6_desc: 'Prime position in Mauritania for African trade routes',
  mau_why7_title: 'Real-Time Tracking',
  mau_why7_desc: 'Advanced systems for complete shipment visibility',
  mau_why8_title: 'Compliance Expertise',
  mau_why8_desc: 'Full regulatory compliance and customs clearance support',

  mau_clients_tag: 'Our Clients',
  mau_clients_title: 'Trusted by Industry Leaders',
  mau_clients_subtitle: 'Leading global companies rely on Mauritrans Shipping for their logistics and maritime needs across Africa',
  mau_clients_note: 'Proudly serving',
  mau_clients_note2: 'and many more global leaders',

  mau_cta_title: 'Ready to Ship\nWith Confidence?',
  mau_cta_subtitle: 'Get a customized logistics solution tailored to your business needs.\nContact our team today for a free consultation and quote.',
  mau_cta_btn1: 'Request Quote',
  mau_cta_btn2: 'WhatsApp Us',

  mau_contact_tag: 'Get In Touch',
  mau_contact_title: 'Contact Mauritrans Shipping',
  mau_contact_subtitle: 'Reach out to discuss your logistics needs and get a customized solution',
  mau_contact_addr_label: 'Address',
  mau_contact_phone_label: 'Phone',
  mau_contact_email_label: 'Email',
  mau_contact_parent_label: 'Parent Company',
  mau_contact_note: 'Mauritrans Shipping is a wholly-owned subsidiary of GDSATLAS, providing comprehensive logistics and maritime services across Africa.',
  mau_form_title: 'Request a Quote',
  mau_form_company: 'Company Name',
  mau_form_company_ph: 'Your company name',
  mau_form_name: 'Name',
  mau_form_name_ph: 'Your name',
  mau_form_email: 'Email',
  mau_form_email_ph: 'your@email.com',
  mau_form_service: 'Service Required',
  mau_form_service_ph: 'Select a service',
  mau_form_svc_opt1: 'Shipping Agency Services',
  mau_form_svc_opt2: 'Freight Forwarding',
  mau_form_svc_opt3: 'Customs Clearance',
  mau_form_svc_opt4: 'Warehousing',
  mau_form_svc_opt5: 'Inland Transportation',
  mau_form_svc_opt6: 'Other Services',
  mau_form_message: 'Message',
  mau_form_message_ph: 'Tell us about your logistics needs',
  mau_form_submit: 'Submit Request',

  mau_footer_tagline: 'Mauritrans Shipping - Your Complete Logistics & Shipping Partner in Africa',
  mau_footer_subsidiary: 'A wholly-owned subsidiary of GDSATLAS Holding',
  mau_footer_back: 'Back to GDSATLAS Holding',
  mau_footer_links: 'Quick Links',
  mau_footer_services: 'Our Services',
  mau_footer_about: 'About Us',
  mau_footer_contact: 'Contact',
  mau_footer_group: 'GDSATLAS Group',
  mau_footer_copyright: '© 2025 Mauritrans Shipping. A GDSATLAS Company. All rights reserved.',
};

export default mauritransEN;
